
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';
import { JobComplianceData } from '@/models/JobComplianceTypes';
import { mapState } from 'vuex';
import { User } from '@/models/main';

@Component({
  components: {
    Icon,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class Add3rdStop extends Vue {
  @Prop({ type: Object, required: false, default: false }) public formData: JobComplianceData;

  private user!: User;
  public loading = false;

  public add3rdStop() {
    this.$emit('addTmp3rdStop');
  }
}
